"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const PropTypes = __importStar(require("prop-types"));
const clsx_1 = require("clsx");
const interfaces_1 = require("./interfaces");
const Banner = (_a) => {
    var { className, isClosable, onClose, actionText, onAction, content, show, variant, size } = _a, otherProps = __rest(_a, ["className", "isClosable", "onClose", "actionText", "onAction", "content", "show", "variant", "size"]);
    if (!show) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, clsx_1.clsx)('tk-banner', `tk-banner--${variant}`, `tk-banner--${size}`, { [className]: !!className }) }, otherProps, { children: [(0, jsx_runtime_1.jsx)("div", { className: "tk-banner__variant-icon" }), (0, jsx_runtime_1.jsx)("div", { className: "tk-banner__content", children: content }), actionText && onAction && ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: onAction, className: "tk-banner__action", children: actionText })), isClosable && onClose && ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "tk-banner__close", onClick: onClose }))] })));
};
exports.Banner = Banner;
exports.Banner.defaultProps = {
    variant: interfaces_1.BannerType.INFO,
    size: 'medium',
    show: true,
};
exports.Banner.propTypes = {
    className: PropTypes.string,
    isClosable: PropTypes.bool,
    content: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    show: PropTypes.bool,
    variant: PropTypes.oneOf(Object.values(interfaces_1.BannerType)),
    size: PropTypes.oneOf(['small', 'medium']),
    actionText: PropTypes.string,
    onAction: PropTypes.func,
};
